const color = {
  primary: "#EE1C25",
};

export default color;
